module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "List_of_Plates"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('b', [_c('i', [_vm._v("Plates")])])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "img-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Austrian artillery. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Marine Artillery. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Artillery mounted rocket corps. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marshal Vauban. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The siege of Copenhagen. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The French siege of Saragossa. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The British assault on the breach of Ciudad Rodrigo. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Badajoz from across the river. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The British assault at Badajoz. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The British siege of San Sebastian. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The second siege of Danzig, 1813. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Danish Army at the siege of Hamburg in 1813–14. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Royal Military Academy, Woolwich. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ciudad Rodrigo, the approach to the ‘castle’. "), _c('i', [_vm._v("(Rod MacArthur)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ciudad Rodrigo, curtain wall and outworks. "), _c('i', [_vm._v("(Rod MacArthur)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prussian artillery. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Isaac Hull. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commodore Oliver Hazard Perry. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Navy boats attacking a privateer. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The battle of Lake Erie. "), _c('i', [_vm._v("(Anne Brown Collection, Brown University)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fort Ticonderoga. "), _c('i', [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fort Ticonderoga, drawbridge and redan. "), _c('i', [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One of the Fort Ticonderoga bastions. "), _c('i', [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("place d’armes")]), _vm._v(", Fort Ticonderoga. "), _c('i', [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fort McHenry aerial view. "), _c('i', [_vm._v("(Fort McHenry National Historic Site)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curtain wall, bastion, and outworks, Fort McHenry. "), _c('i', [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The replica water battery at Fort McHenry. "), _c('i', [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One of the mortar bombs actually fired on Fort McHenry. "), _c('i', [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fort McHenry magazine. "), _c('i', [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artillery implements, Fort McHenry. "), _c('i', [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "img-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#ufig_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naval gun and tackle, Fort McHenry. "), _c('i', [_vm._v("(Author’s collection)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4411f30d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_List_of_Plates.vue
// module id = 75
// module chunks = 0